module.exports = __webpack_public_path__ + "Icon_Crash forces@2x.png?8e9b342693e4c83c887f93f5b5a44c53";